import { render, staticRenderFns } from "./CaixaFechamento.vue?vue&type=template&id=55dd75f6&scoped=true"
import script from "./CaixaFechamento.vue?vue&type=script&lang=js"
export * from "./CaixaFechamento.vue?vue&type=script&lang=js"
import style1 from "./CaixaFechamento.vue?vue&type=style&index=1&id=55dd75f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd75f6",
  null
  
)

export default component.exports